module.exports = __webpack_public_path__ + "media/images/flags/1x1/pse-6207d909c4c504cf3758309c8d6655c7.svg";